import certificatPreview from '../imagesHome/certificatPreview.png';
import './CertificateSection.css';

export default function CertificateSection({ image = certificatPreview }) {
  return (
    <section
      className="cl-certificate"
      aria-label="Certificate de competente ContaLearn"
    >
      <div className="cl-certificate__inner">
        <div className="cl-certificate__media">
          <img
            className="cl-certificate__image"
            src={image}
            alt="Exemplu de certificat de competente ContaLearn pentru cursul Bazele contabilitatii"
            width="886"
            height="608"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="cl-certificate__copy">
          <h2 className="cl-certificate__title">
            Demonstreaza ce ai invatat
          </h2>
          <p className="cl-certificate__description">
            Finalizeaza cursurile si obtine{' '}
            <strong>certificate de competente ContaLearn</strong>{' '}
            care confirma progresul tau. Fiecare certificat este{' '}
            <strong>unic si verificabil</strong>, astfel incat il poti folosi
            pentru a-ti prezenta cunostintele dobandite.
          </p>
        </div>
      </div>
    </section>
  );
}
